import { render } from "./term.vue?vue&type=template&id=42e3fb08&scoped=true"
const script = {}

import "./term.vue?vue&type=style&index=0&id=42e3fb08&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e3fb08"]])

export default __exports__